var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',{staticClass:"quadia-live-admin grey lighten-4"},[_c('app-bar'),_c('router-view'),_c('snack-bar')],1)}
var staticRenderFns = []

export { render, staticRenderFns }